import { Box, Typography } from "@mui/material";
import React from "react";
import Logo from "../../assets/icons/Logo.png";
import AnchorTemporaryDrawer from "./NavDrawer";
import { NavLink } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import DesignElement from "../../assets/images/NavbarRight.png";

const Navbar = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: "10",
        width: "100%",
        height: "6rem",
        // backgroundColor: "rgba(243, 107, 43, 1)",
        background: "linear-gradient(to bottom, #f46f2c, #f47b2a, #f26b27)",
        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
      }}
    >
      <Box
        sx={{
          height: "100%",
          maxWidth: { xs: "100%", sm: "1440px" },
          margin: "0 auto",
          padding: { xs: "0rem 2rem", sm: "0rem 2rem" },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        {/* Wrap the logo in NavLink */}
        <NavLink to="/" style={{ width: "fit-content" }}>
          <Box
            sx={{
              width: { xs: "6rem", sm: "9rem" },
            }}
          >
            <img src={Logo} alt="Logo" width="90%" />
          </Box>
        </NavLink>

        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            width: "50%",
            justifyContent: "space-between",
            fontFamily: "Montserrat",
            color: "white",
          }}
        >
          <Typography sx={{ fontFamily: "Montserrat" }}>
            <NavLink to="/" style={{ textDecoration: "none", color: "white" }}>
              Home
            </NavLink>
          </Typography>

          <Typography sx={{ fontFamily: "Montserrat" }}>
            <NavLink
              to="/aboutus"
              style={{ textDecoration: "none", color: "white" }}
            >
              About us
            </NavLink>
          </Typography>

          <Typography sx={{ fontFamily: "Montserrat" }}>
            <NavLink
              to="/solutions"
              style={{ textDecoration: "none", color: "white" }}
            >
              Solutions
            </NavLink>
          </Typography>

          <Typography sx={{ fontFamily: "Montserrat" }}>
            <NavLink
              to="/casestudies"
              style={{ textDecoration: "none", color: "white" }}
            >
              Case Studies
            </NavLink>
          </Typography>

          <Typography sx={{ fontFamily: "Montserrat" }}>
            <NavLink
              to="/thinking"
              style={{ textDecoration: "none", color: "white" }}
            >
              Thinking
            </NavLink>
          </Typography>

          <Typography sx={{ fontFamily: "Montserrat" }}>
            <NavLink
              to="/events"
              style={{ textDecoration: "none", color: "white" }}
            >
              Events
            </NavLink>
          </Typography>

          <Typography sx={{ fontFamily: "Montserrat" }}>
            <NavLink
              to="/contactus"
              style={{ textDecoration: "none", color: "white" }}
            >
              Contact Us
            </NavLink>
          </Typography>
        </Box>

        {/* Add Design Element Image for Desktop */}
        <Box
          sx={{
            position: "absolute",
            right: "-2rem", // Adjust as needed for positioning
            top: "-1rem", // Adjust as needed for positioning
            width: "6rem",
            opacity: 0.8,
            zIndex: 1, // Lower zIndex for design element
          }}
        >
          <LazyLoadImage
            src={DesignElement}
            effect="blur"
            width="100%"
            height="100%"
            alt="top right img"
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: { sm: "initial", md: "none" },
          position: "absolute",
          right: "2rem",
          top: "1.8rem",
          zIndex: 10,
        }}
      >
        <AnchorTemporaryDrawer />
      </Box>
    </Box>
  );
};

export default Navbar;
